// Dashboard.jsx

import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { ESTABELECIMENTO_TEMPLATES } from '../config/templates'; 
import '../styles/Dashboard.css';
import io from 'socket.io-client';

const RESERVED_SLUGS = ['dashboard', 'admin', 'login', 'api', 'editor', 'produtos'];

export default function Dashboard() {
    const useNavigateInstance = useNavigate();
    
    // Verificação estrita de segurança do Admin Master
    const userRole = localStorage.getItem('userRole');
    const rawEstabId = localStorage.getItem('estabelecimentoId');
    const estabelecimentoId = (!rawEstabId || rawEstabId === 'null' || rawEstabId === 'undefined' || rawEstabId === '') ? null : rawEstabId;

    // --- ESTADOS: GERAIS ---
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('estabelecimentos'); // 'estabelecimentos'

    // --- ESTADOS: ESTABELECIMENTOS ---
    const [clientes, setClientes] = useState([]);
    const [currentPageClientes, setCurrentPageClientes] = useState(1);
    const itemsPerPageClientes = 8;
    const [socket, setSocket] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [statusIdTarget, setStatusIdTarget] = useState(null);
    const [currentStatusTarget, setCurrentStatusTarget] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [editandoId, setEditandoId] = useState(null);
    const fileInputRef = useRef(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [logoFile, setLogoFile] = useState(null);

    // --- ESTADOS: PAINEL DE ALERTAS PADRONIZADOS EM MASSA ---
    const [showAlertaModal, setShowAlertaModal] = useState(false);
    const [alertaCustomizado, setAlertaCustomizado] = useState('');
    const [alertaEnviando, setAlertaEnviando] = useState(false);
    
    const initialState = {
        nome: '', slug: '', layout_tipo: 'restaurante', banner_url: '', cep: '',
        whatsapp: '', endereco: '', rua: '', numero: '', complemento: '',
        bairro: '', cidade: '', estado: '', instagram: '', documento: '', 
        site_oficial: '', email_representante: '', senha_inicial: '123456',
        limite_produtos: 50,
        status_assinatura: 'ativo',
        data_vencimento: ''
    };
    const [novoCliente, setNovoCliente] = useState(initialState);

    // Validação de Rota e Sessão (BLOQUEIO RIGOROSO DO ADMIN DA LOJA)
    useEffect(() => {
        if (estabelecimentoId || userRole !== 'admin_master') {
            toast.error("Acesso negado. Área restrita ao Admin Master.");
            setTimeout(() => {
                if (estabelecimentoId) {
                    useNavigateInstance('/minha-loja', { replace: true });
                } else {
                    useNavigateInstance('/', { replace: true });
                }
            }, 100);
            return;
        }
        carregarTudo();
    }, [estabelecimentoId, userRole, useNavigateInstance]);

    // --- FUNÇÕES DE CARREGAMENTO INTELIGENTE ---
    const carregarTudo = async () => {
        setLoading(true);
        try {
            const resClientes = await api.get('/cardapio/clientes')
                .catch(() => api.get('/cardapio/estabelecimentos'))
                .catch(() => api.get('/estabelecimentos'));
            
            const payloadData = resClientes?.data;
            const dadosClientes = Array.isArray(payloadData) 
                ? payloadData 
                : (payloadData?.estabelecimentos || payloadData?.clientes || payloadData?.data || []);

            setClientes(dadosClientes);
        } catch (e) {
            console.error("Erro ao carregar dados do painel:", e);
            toast.error("Erro ao carregar a lista de estabelecimentos.");
            setClientes([]);
        } finally {
            setLoading(false);
        }
    };

    // --- LÓGICA DE PAGINAÇÃO ---
    const indexOfLastCliente = currentPageClientes * itemsPerPageClientes;
    const indexOfFirstCliente = indexOfLastCliente - itemsPerPageClientes;
    const currentClientes = clientes.slice(indexOfFirstCliente, indexOfLastCliente);
    const totalPagesClientes = Math.ceil(clientes.length / itemsPerPageClientes) || 1;

    // Conexão Socket Global
    useEffect(() => {
        const newSocket = io('https://app.universomidiadigital.com.br', {
            transports: ['websocket']
        });
        setSocket(newSocket);
        return () => newSocket.close();
    }, []);

    // Função para disparar Alerta Individual para a loja
    const handleDispararAlertaVencimento = async (cli) => {
        const mensagemAlerta = `⚠️ AVISO DA PLATAFORMA: Sua assinatura encontra-se com pendência de pagamento ou vencida. Regularize o quanto antes para evitar o bloqueio total do acesso ao seu cardápio.`;
        try {
            await api.post(`/cardapio/estabelecimentos/${cli.id}/alerta`, { mensagem: mensagemAlerta });
            toast.success(`Alerta de cobrança enviado para ${cli.nome}!`);
        } catch (err) {
            toast.error("Erro ao enviar alerta para a loja.");
        }
    };

    // Função para disparar Alerta Padronizado em Massa para TODAS as Lojas
    const handleEnviarAlertaGeral = async (mensagemPadrao) => {
        const textoFinal = mensagemPadrao || alertaCustomizado;
        if (!textoFinal.trim()) {
            return toast.error("Digite ou selecione uma mensagem de alerta.");
        }

        setAlertaEnviando(true);
        try {
            await Promise.all(
                clientes.map(cli => 
                    api.post(`/cardapio/estabelecimentos/${cli.id}/alerta`, { mensagem: textoFinal }).catch(() => {})
                )
            );
            toast.success("Alerta transmitido com sucesso para todas as lojas!");
            setShowAlertaModal(false);
            setAlertaCustomizado('');
        } catch (e) {
            toast.error("Erro ao transmitir alerta em massa.");
        } finally {
            setAlertaEnviando(false);
        }
    };

    // Configura limite de acordo com o plano selecionado no Admin Master
    const handlePlanoChange = (e) => {
        const limite = parseInt(e.target.value);
        
        const hoje = new Date();
        hoje.setDate(hoje.getDate() + 30);
        const dataFormatada = hoje.toISOString().split('T')[0];

        setNovoCliente(prev => ({
            ...prev,
            limite_produtos: limite,
            data_vencimento: prev.data_vencimento || dataFormatada
        }));
    };

    const handleCEPChange = async (e) => {
        const cep = e.target.value.replace(/\D/g, '');
        setNovoCliente({ ...novoCliente, cep: e.target.value });

        if (cep.length === 8) {
            try {
                const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
                if (!response.data.erro) {
                    const { logradouro, bairro, localidade, uf } = response.data;
                    setNovoCliente(prev => ({
                        ...prev, cep: cep, rua: logradouro, bairro: bairro,
                        cidade: localidade, estado: uf,
                        endereco: `${logradouro}, ${bairro} - ${localidade}/${uf}`
                    }));
                    toast.success("Endereço localizado com sucesso!");
                } else {
                    toast.error("CEP não encontrado.");
                }
            } catch (err) { 
                toast.error("Erro ao buscar CEP."); 
            }
        }
    };
    
    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const abrirEdicao = (cli) => {
        setEditandoId(cli.id);
        
        let dataVencFormatada = '';
        if (cli.data_vencimento) {
            dataVencFormatada = new Date(cli.data_vencimento).toISOString().split('T')[0];
        }

        setNovoCliente({ 
            ...initialState, 
            ...cli, 
            layout_tipo: cli.layout_tipo || 'restaurante',
            limite_produtos: cli.limite_produtos || 50,
            status_assinatura: cli.status_assinatura || 'ativo',
            data_vencimento: dataVencFormatada
        });
        setLogoPreview(cli.logo_url);
        setShowModal(true);
    };

    const fecharModal = () => {
        setShowModal(false);
        setEditandoId(null);
        setNovoCliente(initialState);
        setLogoPreview(null);
        setLogoFile(null);
    };

    const handleSalvar = async (e) => {
        e.preventDefault();
        if (RESERVED_SLUGS.includes(novoCliente.slug.toLowerCase())) {
            return toast.error("Este nome de link é reservado pelo sistema.");
        }
        
        const formData = new FormData();
        Object.keys(novoCliente).forEach(key => {
            if (novoCliente[key] !== null && novoCliente[key] !== undefined) {
                formData.append(key, novoCliente[key]);
            }
        });
        if (logoFile) formData.append('logo', logoFile);

        try {
            if (editandoId) {
                const response = await api.put(`/cardapio/estabelecimentos/${editandoId}`, formData);
                toast.success(response.data.message || "Estabelecimento atualizado com sucesso!");
                
                await api.post(`/cardapio/estabelecimentos/${editandoId}/alerta`, { 
                    mensagem: `✨ ATUALIZAÇÃO DE PLANO: Seu plano e limites de produtos foram atualizados pela administração. Aproveite os novos recursos!` 
                }).catch(() => {});

            } else {
                const response = await api.post('/cardapio/clientes', formData);
                toast.success(response.data.message || "Estabelecimento criado com sucesso!");

                if (novoCliente.email_representante) {
                    api.post('/email/boas-vindas', {
                        email: novoCliente.email_representante, nomeEmpresa: novoCliente.nome, slug: novoCliente.slug
                    }).catch(err => console.error("Falha no envio de e-mail de boas-vindas:", err));
                }
            }
            fecharModal();
            carregarTudo();
        } catch (err) {
            toast.error(err.response?.data?.error || "Erro ao salvar estabelecimento.");
        }
    };

    const handleExcluir = async () => {
        try {
            await api.delete(`/cardapio/estabelecimentos/${selectedId}`);
            toast.success("Estabelecimento removido com sucesso!");
            setShowDeleteModal(false);
            carregarTudo();
        } catch (e) { 
            toast.error("Erro ao excluir estabelecimento."); 
        }
    };

    const handleToggleStatus = async () => {
        if (!statusIdTarget) return;
        try {
            const isAtualmenteInativo = checkInativo(currentStatusTarget);
            const novoStatus = isAtualmenteInativo ? 1 : 0; 
            await api.patch(`/cardapio/estabelecimentos/${statusIdTarget}/status`, { ativo: novoStatus });
            toast.success(novoStatus === 1 ? "Loja ativada com sucesso!" : "Loja inativada com sucesso!");
            setShowStatusModal(false);
            carregarTudo(); 
        } catch (e) { 
            toast.error("Erro ao alterar o status da loja."); 
        }
    };

    const checkInativo = (ativo) => ativo === 0 || ativo === '0' || ativo === false;

    const PaginationControls = ({ currentPage, totalPages, setCurrentPage }) => {
        if (totalPages <= 1) return null;
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', marginTop: '20px', padding: '10px' }}>
                <button 
                    onClick={() => setCurrentPage(p => Math.max(1, p - 1))} 
                    disabled={currentPage === 1}
                    style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: currentPage === 1 ? '#f5f5f5' : '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', color: currentPage === 1 ? '#999' : '#333' }}
                >
                    Anterior
                </button>
                <span style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>
                    Página {currentPage} de {totalPages}
                </span>
                <button 
                    onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} 
                    disabled={currentPage === totalPages}
                    style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: currentPage === totalPages ? '#f5f5f5' : '#fff', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', color: currentPage === totalPages ? '#999' : '#333' }}
                >
                    Próxima
                </button>
            </div>
        );
    };

    return (
        <div className="dashboard-page">
            <Toaster position="top-right" />
            <header className="dashboard-header">
                <h2 className="dashboard-logo">
                    Universo Mídia <b>Digital</b> 
                    <span style={{fontSize: '11px', background: '#ea1d2c', color: '#fff', padding: '3px 8px', borderRadius: '4px', marginLeft: '10px'}}>
                        Admin Master Root
                    </span>
                </h2>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <button 
                        onClick={() => setShowAlertaModal(true)}
                        style={{ background: '#2563eb', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}
                    >
                        📢 Disparar Alerta Padronizado
                    </button>
                    <button onClick={() => { localStorage.clear(); window.location.href = '/' }} className="btn-sair">Sair</button>
                </div>
            </header>

            <main className="dashboard-container">
                <div className="top-info">
                    <h1>Painel Master de Lojas e Planos</h1>
                    <p>Controle absoluto de estabelecimentos, limites de produtos, datas de vencimento e acessos da plataforma.</p>
                </div>

                <div className="dashboard-tabs" style={{ display: 'flex', gap: '15px', marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
                    <button 
                        style={{ background: 'none', border: 'none', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', color: '#ea1d2c', borderBottom: '3px solid #ea1d2c', paddingBottom: '5px' }}
                    >
                        🏪 Estabelecimentos & Assinaturas ({clientes.length})
                    </button>
                </div>

                <>
                    <div className="dashboard-grid">
                        <div className="add-card" onClick={() => setShowModal(true)}>
                            <div className="plus-circle">+</div>
                            <p>Cadastrar Novo Estabelecimento</p>
                        </div>

                        {!loading && currentClientes.map(cli => {
                            const isInativo = checkInativo(cli.ativo);
                            const limiteProd = cli.limite_produtos || 50;
                            const statusAssinatura = cli.status_assinatura || 'ativo';
                            
                            return (
                            <div key={cli.id} className="card" style={{ opacity: isInativo ? 0.7 : 1, transition: '0.3s' }}>
                                <div className="card-header">
                                    <div className="avatar">
                                        {cli.logo_url ? (
                                            <img src={cli.logo_url} alt="" style={{width: '100%', height: '100%', borderRadius: '12px', objectFit: 'cover'}} />
                                        ) : (
                                            <span>{ESTABELECIMENTO_TEMPLATES[cli.layout_tipo]?.icon || '🏪'}</span>
                                        )}
                                    </div>
                                    <div className="title-group">
                                        <h3 className="card-title" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                            {cli.nome} 
                                            
                                            <button 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setStatusIdTarget(cli.id);
                                                    setCurrentStatusTarget(cli.ativo);
                                                    setShowStatusModal(true);
                                                }}
                                                style={{
                                                    fontSize: '11px', padding: '4px 10px', borderRadius: '20px',
                                                    backgroundColor: isInativo ? '#fee2e2' : '#dcfce7',
                                                    color: isInativo ? '#991b1b' : '#166534',
                                                    border: 'none', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px'
                                                }}
                                                title="Clique para alterar status"
                                            >
                                                <span style={{ fontSize: '8px' }}>{isInativo ? '🔴' : '🟢'}</span>
                                                {isInativo ? 'Desativada' : 'Ativa'}
                                            </button>
                                        </h3>
                                        <div className="badge-nicho">{ESTABELECIMENTO_TEMPLATES[cli.layout_tipo]?.label || 'Restaurante'}</div>
                                        <small className="slug-url">universo.com.br/{cli.slug}</small>
                                        
                                        {cli.email_representante && (
                                            <div style={{ fontSize: '11px', color: '#444', marginTop: '4px' }}>
                                                ✉️ <b>{cli.email_representante}</b>
                                            </div>
                                        )}

                                        <div style={{ marginTop: '8px', padding: '8px', background: '#f8fafc', borderRadius: '6px', border: '1px solid #e2e8f0', fontSize: '11px' }}>
                                            <div>📦 <b>Plano Limite:</b> {limiteProd >= 99999 ? 'Ilimitado' : `${limiteProd} produtos`}</div>
                                            <div>💰 <b>Status Assinatura:</b> <span style={{ color: statusAssinatura === 'ativo' ? '#16a34a' : '#dc2626', textTransform: 'uppercase', fontWeight: 'bold' }}>{statusAssinatura}</span></div>
                                            <div>📅 <b>Vencimento:</b> {cli.data_vencimento ? new Date(cli.data_vencimento).toLocaleDateString('pt-BR') : 'Não definido'}</div>
                                            
                                            {cli.data_vencimento && (() => {
                                                const hoje = new Date();
                                                const vencimento = new Date(cli.data_vencimento);
                                                const diffTime = vencimento - hoje;
                                                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                                if (diffDays < 0) {
                                                    return (
                                                        <div style={{ marginTop: '6px', padding: '6px', background: '#fee2e2', color: '#991b1b', borderRadius: '4px', fontWeight: 'bold', textAlign: 'center', border: '1px solid #f87171' }}>
                                                            🚨 VENCIDO! O bloqueio do acesso ocorrerá caso o pagamento não seja efetuado.
                                                            <div style={{ marginTop: '4px' }}>
                                                                <button 
                                                                    onClick={() => handleDispararAlertaVencimento(cli)}
                                                                    style={{ background: '#dc2626', color: '#fff', border: 'none', padding: '3px 8px', borderRadius: '4px', fontSize: '10px', cursor: 'pointer', fontWeight: 'bold' }}
                                                                >
                                                                    📢 Enviar Alerta Pop-up p/ Loja
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                                } else if (diffDays <= 5) {
                                                    return (
                                                        <div style={{ marginTop: '6px', padding: '6px', background: '#fef3c7', color: '#92400e', borderRadius: '4px', fontWeight: 'bold', textAlign: 'center', border: '1px solid #fcd34d' }}>
                                                            ⚠️ Vence em {diffDays} {diffDays === 1 ? 'dia' : 'dias'}! Regularize para evitar o bloqueio.
                                                            <div style={{ marginTop: '4px' }}>
                                                                <button 
                                                                    onClick={() => handleDispararAlertaVencimento(cli)}
                                                                    style={{ background: '#d97706', color: '#fff', border: 'none', padding: '3px 8px', borderRadius: '4px', fontSize: '10px', cursor: 'pointer', fontWeight: 'bold' }}
                                                                >
                                                                    📢 Enviar Alerta Pop-up p/ Loja
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                return null;
                                            })()}
                                        </div>
                                    </div>
                                </div>

                                <div className="actions-main">
                                    <Link to={`/produtos/${cli.id}`} className="btn-data">📦 Gerenciar Produtos</Link>
                                    <Link to={`/editor/${cli.id}`} className="btn-primary">🎨 Moldar Arte & Exportar</Link>
                                    <Link to={`/${cli.slug}`} target="_blank" rel="noopener noreferrer" className="btn-secondary">👁️ Ver Cardápio Online</Link>
                                </div>

                                <div className="card-footer">
                                    <div className="footer-links">
                                        <button onClick={() => abrirEdicao(cli)} className="btn-text">⚙️ Configurar / Plano</button>
                                        <button onClick={() => {
                                            navigator.clipboard.writeText(`https://app.universomidiadigital.com.br/${cli.slug}`);
                                            toast.success("Link copiado!");
                                        }} className="btn-text">Copiar Link</button>
                                    </div>
                                    <button onClick={() => { setSelectedId(cli.id); setShowDeleteModal(true) }} className="btn-delete-text">Excluir</button>
                                </div>
                            </div>
                        )})}
                    </div>
                    
                    <PaginationControls 
                        currentPage={currentPageClientes} 
                        totalPages={totalPagesClientes} 
                        setCurrentPage={setCurrentPageClientes} 
                    />
                </>
            </main>

            {/* MODAL DE ALERTAS PADRONIZADOS EM MASSA */}
            {showAlertaModal && (
                <div className="modal-overlay" onClick={() => setShowAlertaModal(false)}>
                    <div className="modal" style={{ maxWidth: '500px', padding: '25px' }} onClick={e => e.stopPropagation()}>
                        <h3 style={{ marginTop: 0, marginBottom: '15px', color: '#1e293b' }}>📢 Disparar Alerta Padronizado</h3>
                        <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '20px' }}>
                            Escolha um modelo de aviso rápido ou escreva uma mensagem personalizada. Ela aparecerá em pop-up para todas as lojas da plataforma.
                        </p>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
                            <button 
                                onClick={() => handleEnviarAlertaGeral("🛠️ AVISO DE MANUTENÇÃO: O sistema passará por atualizações programadas nas próximas horas. O cardápio continuará operando normalmente após a conclusão.")}
                                style={{ padding: '10px', background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '8px', textAlign: 'left', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                            >
                                🛠️ Modelo: Manutenção do Sistema
                            </button>
                            <button 
                                onClick={() => handleEnviarAlertaGeral("💳 ATUALIZAÇÃO DE PLANO/FATURA: Sua assinatura foi atualizada com sucesso. Verifique seu painel de faturas.")}
                                style={{ padding: '10px', background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '8px', textAlign: 'left', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                            >
                                💳 Modelo: Atualização de Plano / Fatura
                            </button>
                            <button 
                                onClick={() => handleEnviarAlertaGeral("⚠️ COMUNICADO IMPORTANTE: Identificamos pendências em sua assinatura. Regularize para evitar interrupções.")}
                                style={{ padding: '10px', background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: '8px', textAlign: 'left', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                            >
                                ⚠️ Modelo: Aviso de Vencimento Geral
                            </button>
                        </div>

                        <label className="label" style={{ fontSize: '12px' }}>Ou digite uma mensagem personalizada:</label>
                        <textarea 
                            className="input" 
                            rows="4" 
                            value={alertaCustomizado}
                            onChange={e => setAlertaCustomizado(e.target.value)}
                            placeholder="Digite o texto do alerta..."
                            style={{ resize: 'vertical', marginBottom: '20px', fontFamily: 'inherit' }}
                        />

                        <div className="modal-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button onClick={() => setShowAlertaModal(false)} className="btn-text">Cancelar</button>
                            <button 
                                onClick={() => handleEnviarAlertaGeral(alertaCustomizado)}
                                disabled={alertaEnviando}
                                className="btn-confirm" 
                                style={{ backgroundColor: '#2563eb', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}
                            >
                                {alertaEnviando ? 'Enviando...' : 'Transmitir Alerta'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL DE CADASTRO / EDIÇÃO DE ESTABELECIMENTO E PLANOS */}
            {showModal && (
            <div className="modal-overlay" onClick={fecharModal}>
                <div className="modal" style={{ maxWidth: '800px', padding: '30px' , maxHeight:'90vh', overflowY: 'auto'}} onClick={e => e.stopPropagation()}>
                    <h2 style={{ marginBottom: '20px', marginTop: '0' }}>{editandoId ? 'Gerenciar Estabelecimento & Assinatura' : 'Cadastrar Novo Estabelecimento'}</h2>
                    
                    <form onSubmit={handleSalvar}>
                        <div style={{ marginBottom: '20px', padding: '15px', background: '#f1f5f9', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
                            <h4 style={{ margin: '0 0 10px 0', color: '#1e293b' }}>💳 Controle de Assinatura e Planos</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
                                <div>
                                    <label className="label" style={{ fontSize: '12px' }}>Plano / Limite de Produtos</label>
                                    <select 
                                        className="input" 
                                        value={novoCliente.limite_produtos} 
                                        onChange={handlePlanoChange}
                                        style={{ fontSize: '12px' }}
                                    >
                                        <option value={50}>Plano Express: Até 50 Prod (R$ 49,90)</option>
                                        <option value={100}>Plano Standard: Até 100 Prod (R$ 79,90)</option>
                                        <option value={300}>Plano Premium: Até 300 Prod (R$ 99,90)</option>
                                        <option value={99999}>Plano Enterprise: Ilimitado (R$ 149,90)</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="label" style={{ fontSize: '12px' }}>Status da Assinatura</label>
                                    <select 
                                        className="input" 
                                        value={novoCliente.status_assinatura} 
                                        onChange={e => setNovoCliente({ ...novoCliente, status_assinatura: e.target.value })}
                                        style={{ fontSize: '12px' }}
                                    >
                                        <option value="ativo">Ativo</option>
                                        <option value="pendente">Pendente</option>
                                        <option value="vencido">Vencido</option>
                                        <option value="cancelado">Cancelado</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="label" style={{ fontSize: '12px' }}>Data de Vencimento</label>
                                    <input 
                                        type="date" 
                                        className="input" 
                                        value={novoCliente.data_vencimento} 
                                        onChange={e => setNovoCliente({ ...novoCliente, data_vencimento: e.target.value })}
                                        style={{ fontSize: '12px' }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                            <div>
                                <label className="label">Template Visual (Nicho)</label>
                                <select 
                                    className="input" 
                                    value={novoCliente.layout_tipo} 
                                    onChange={e => {
                                        const nicho = e.target.value;
                                        setNovoCliente({
                                            ...novoCliente, layout_tipo: nicho, banner_url: ESTABELECIMENTO_TEMPLATES[nicho]?.banner || ''
                                        });
                                    }}
                                >
                                    {Object.values(ESTABELECIMENTO_TEMPLATES).map(t => (
                                        <option key={t.id} value={t.id}>{t.icon} {t.label}</option>
                                    ))}
                                </select>
        
                                <label className="label">Logo da Empresa</label>
                                <div className="image-preview-container" onClick={() => fileInputRef.current.click()} style={{ border: '2px dashed #ccc', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '15px' }}>
                                    {logoPreview ? <img src={logoPreview} className="image-preview-img" alt="" style={{ maxHeight: '100%', maxWidth: '100%' }} /> : <div className="image-preview-placeholder">Clique para Upload</div>}
                                </div>
                                <input type="file" ref={fileInputRef} hidden onChange={handleLogoChange} accept="image/*" />
        
                                <label className="label">Nome da Empresa</label>
                                <input className="input" value={novoCliente.nome} onChange={e => {
                                    const val = e.target.value;
                                    const slug = val.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, '-');
                                    setNovoCliente({ ...novoCliente, nome: val, slug: slug });
                                }} required />
        
                                <label className="label">CPF/CNPJ</label>
                                <input className="input" value={novoCliente.documento} onChange={e => setNovoCliente({ ...novoCliente, documento: e.target.value })} placeholder="000.000.000-00" />
                                
                                <label className="label">Site Oficial</label>
                                <input className="input" value={novoCliente.site_oficial} onChange={e => setNovoCliente({ ...novoCliente, site_oficial: e.target.value })} placeholder="https://site.com.br" />
                            </div>
        
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                <label className="label">Email do Representante (Login e Contato)</label>
                                <input 
                                    type="email" className="input" value={novoCliente.email_representante} 
                                    onChange={e => setNovoCliente({ ...novoCliente, email_representante: e.target.value })} 
                                    placeholder="email@exemplo.com" required
                                />
                                <small style={{color: '#666', marginBottom: '10px'}}>Este e-mail será usado para o login e notificações da loja.</small>
        
                                <label className="label">Link do Cardápio (Slug)</label>
                                <input className="input" value={novoCliente.slug} readOnly style={{backgroundColor: '#f1f1f1'}} />
        
                                <label className="label">CEP:</label>
                                <input className="input" value={novoCliente.cep} onChange={handleCEPChange} placeholder="00000-000" />
        
                                <label className="label">Rua / Logradouro</label>
                                <input className="input" value={novoCliente.rua} onChange={e => setNovoCliente({ ...novoCliente, rua: e.target.value })} />

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '10px' }}>
                                    <div>
                                        <label className="label">Número</label>
                                        <input className="input" value={novoCliente.numero} onChange={e => setNovoCliente({ ...novoCliente, numero: e.target.value })} placeholder="S/N" />
                                    </div>
                                    <div>
                                        <label className="label">Bairro</label>
                                        <input className="input" value={novoCliente.bairro} onChange={e => setNovoCliente({ ...novoCliente, bairro: e.target.value })} />
                                    </div>
                                </div>
                                
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '10px' }}>
                                    <div>
                                        <label className="label">Cidade</label>
                                        <input className="input" value={novoCliente.cidade} onChange={e => setNovoCliente({ ...novoCliente, cidade: e.target.value })} />
                                    </div>
                                    <div>
                                        <label className="label">UF</label>
                                        <input className="input" value={novoCliente.estado} onChange={e => setNovoCliente({ ...novoCliente, estado: e.target.value })} maxLength="2" />
                                    </div>
                                </div>
        
                                <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px'}}>
                                    <div>
                                        <label className="label">WhatsApp</label>
                                        <input className="input" value={novoCliente.whatsapp} onChange={e => setNovoCliente({ ...novoCliente, whatsapp: e.target.value })} />
                                    </div>
                                    <div>
                                        <label className="label">Instagram</label>
                                        <input className="input" value={novoCliente.instagram} onChange={e => setNovoCliente({ ...novoCliente, instagram: e.target.value })} />
                                    </div>
                                </div>
        
                                <label className="label">Banner (URL)</label>
                                <input 
                                    className="input" value={novoCliente.banner_url} 
                                    onChange={e => setNovoCliente({ ...novoCliente, banner_url: e.target.value })} 
                                    placeholder="https://imagem.com/fundo.jpg" 
                                />
                            </div>
                        </div>
        
                        <div className="modal-buttons" style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button type="button" onClick={fecharModal} className="btn-text">Cancelar</button>
                            <button type="submit" className="btn-confirm" style={{ backgroundColor: '#28a745', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
                                {editandoId ? 'Salvar Alterações' : 'Cadastrar Estabelecimento'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            )}

            {/* MODAL DE EXCLUSÃO */}
            {showDeleteModal && (
                <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
                    <div className="modal-confirm" onClick={e => e.stopPropagation()}>
                        <div className="warning-icon">!</div>
                        <h3>Excluir permanentemente?</h3>
                        <p>Deseja remover o estabelecimento <b>{clientes.find(c => c.id === selectedId)?.nome}</b>?</p>
                        <div className="modal-buttons">
                            <button onClick={() => setShowDeleteModal(false)} className="btn-cancel">Cancelar</button>
                            <button onClick={handleExcluir} className="btn-confirm-delete">Confirmar Exclusão</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL DE STATUS (ATIVAR/INATIVAR) */}
            {showStatusModal && (
                <div className="modal-overlay" onClick={() => setShowStatusModal(false)}>
                    <div className="modal-confirm" onClick={e => e.stopPropagation()}>
                        <div className="warning-icon" style={{color: checkInativo(currentStatusTarget) ? '#28a745' : '#dc3545', borderColor: checkInativo(currentStatusTarget) ? '#28a745' : '#dc3545'}}>
                            {checkInativo(currentStatusTarget) ? '✓' : '!'}
                        </div>
                        <h3>{checkInativo(currentStatusTarget) ? 'Ativar Loja?' : 'Desativar Loja?'}</h3>
                        <p>Deseja realmente {checkInativo(currentStatusTarget) ? 'ativar' : 'desativar'} <b>{clientes.find(c => c.id === statusIdTarget)?.nome}</b>?</p>
                        <div className="modal-buttons">
                            <button onClick={() => setShowStatusModal(false)} className="btn-cancel">Cancelar</button>
                            <button 
                                onClick={handleToggleStatus} className="btn-confirm" 
                                style={{ backgroundColor: checkInativo(currentStatusTarget) ? '#28a745' : '#dc3545', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}